import React, { useRef, useEffect, useState } from "react";
import {
  I2cButton,
  I2cAvatar,
  I2cFileUpload,
  I2cInput,
  I2cDialog,
  I2cAlert,
  I2cPhoneField,
  I2cDivider,
  I2cIcon,
  I2cPasswordField,
} from "@webcomponents/i2cwebcomponents/dist/react";
import { useForm, Controller } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import ErrorMessage from "../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { useMutation } from "react-query";
import AlertMessage from "../../Components/SharedComponent/Alert/Alert";
import "./UserProfile.scss";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import { updateValidationSchema } from "./validationSchema";
import { useQuery } from "react-query";
import UserManagmentService from "../../Services/UsermanagmentService";
import { OverlayLoader } from "../../Components/Loader/Loader";
import { useQueryClient } from "react-query";
import PasswordValidator from "../../Components/PasswordValidator/PasswordValidator";
import axiosClient from "../../Services/AxiosClient";
import { getValidPasswordStepsCount } from "./GetPasswordCount";

/**import { getValidPasswordStepsCount } from './GetPasswordCount';
 * UserPofile component for adding or updating a user.
 * @returns {JSX.Element} UserPofile component.
 */
const UserPofile = (props) => {
  // const { notify } = useOutletContext();
  const { id } = useParams();
  const navigate = useNavigate();
  const form = useRef();
  const Manual = useRef(null);
  const [open, setOpen] = useState(false);
  const [profileImg, setProfileImg] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const [currentPass, setCurrentPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [newConfPass, setNewConfirmPass] = useState("");
  const [alertMsg, setAlertMsg] = useState("");
  const [variantType, setVariantType] = useState("");
  const [alertState, setAlertState] = useState(false);
  const [loader, setLoaderState] = useState(false);
  const isUserUpdationError = searchParams.get("user-updation-error") ?? false;
  const isUserUpdated = searchParams.get("user-updated") ?? false;
  const queryClient = useQueryClient();
  // User creation mutation
  const userUpdation = useMutation({
    mutationFn: async (values) => {
      return await UserManagmentService.updateUserProfile(values);
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries(["userProfile"]);
      navigate("/profile?user-updated=true");
    },
    onError: (data) => {
      navigate("/profile?user-updation-error=true");
    },
  });

  const handleAvatarClick = () => {
    Manual.current.shadowRoot
      .querySelector(".dropzone.file-layout-row.dz-clickable.dz--mobile")
      .click();
  };

  // const handleOnI2cUploadComplete = () => {
  //   if (Manual.current.getDropZone().files.length > 0) {
  //     setProfileImg(
  //       Manual.current.getDropZone().files[
  //         Manual.current.getDropZone().files.length - 1
  //       ].dataURL,
  //     );
  //   }
  // };
  const handleButtonClick = () => {
    navigate(".", { replace: true });
  };
  // Fetching user by id query
  const {
    data: user,
    isLoading,
    remove,
  } = useQuery(["userProfileUpdate"], () =>
    UserManagmentService.getUserProfile(),
  );

  /**
   * Handle user updation.
   * @param {object} e - Form event object.
   */
  const handleUserUpdation = (e) => {
    userUpdation.mutate(e);
  };

  // Methods declaration
  const methods = useForm({
    resolver: zodResolver(updateValidationSchema),
    mode: "onChange",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: {
      name: "",
      email: "",
      designation: "",
      contact: "",
      country_code: "",
      company: "",
      // working_hrs: 1,
      role_id: 5,
      is_active: false,
      avatar: "",
    },
  });

  // Hook form method
  const {
    handleSubmit,
    formState: { errors, isValid },
  } = methods;

  useEffect(() => {
    if (user?.data?.data) {
      methods.setValue("company", user?.data?.data?.user?.company ?? "");
      methods.setValue("contact", user?.data?.data?.user?.contact ?? "");
      methods.setValue(
        "country_code",
        user?.data?.data?.user?.country_code ?? "",
      );
      methods.setValue(
        "designation",
        user?.data?.data?.user?.designation ?? "",
      );
      methods.setValue("email", user?.data?.data?.user?.email ?? "");
      methods.setValue("name", user?.data?.data?.user?.name ?? "");
      methods.setValue("working_hrs", user?.data?.data?.user?.working_hrs ?? 1);
      if (Manual?.current?.getDropZone()?.files?.length > 0) {
        setProfileImg(
          Manual.current.getDropZone().files[
            Manual.current.getDropZone().files.length - 1
          ].dataURL,
        );
        methods.setValue(
          "avatar",
          Manual.current.getDropZone().files[
            Manual.current.getDropZone().files.length - 1
          ].dataURL || user?.data?.data?.user?.avatar,
        );
      }
      // methods.setValue("avatar", user?.data?.data?.avatar ?? "");
    }
  }, [user]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) remove();
  }, [localStorage.getItem("token")]);
  const changeUserPassword = useMutation({
    mutationFn: async (values) => {
      setLoaderState(true);
      setAlertState(false);
      return await UserManagmentService.changePassword(values);
    },
    onSuccess: (data) => {
      setOpen(false);
      setVariantType("success");
      setAlertMsg("Password Changed Successfully.");
      setAlertState(true);
      setLoaderState(false);
    },
    onError: (data) => {
      setOpen(false);
      setVariantType("danger");
      setAlertMsg(data.response.message);
      setAlertState(true);
      setLoaderState(false);
    },
  });
  const handlePasswordSubmit = (e) => {
    const body = new FormData();
    body.append("current_password", currentPass);
    body.append("new_password", newPass);
    body.append("new_password_confirmation", newConfPass);
    changeUserPassword.mutate(body);
  };

  /**
   * Render UserPofile component.
   * @returns {JSX.Element} UserPofile component.
   */

  // const validStepCount = "";
  const validStepCount = getValidPasswordStepsCount(newPass);
  const isConfirmPassMatch = newPass === newConfPass;
  useEffect(() => {
    if (isUserUpdationError || isUserUpdated) {
      setTimeout(() => {
        searchParams.delete("user-updation-error");
        searchParams.delete("user-updated");
        setSearchParams(searchParams);
      }, 5000);
    }
  }, [isUserUpdationError, isUserUpdated]);
  // if (isLoading || userUpdation.isLoading) return <OverlayLoader />;
  return (
    <React.Fragment>
      <div className="layout_aside user-profile-form-container">
        <div className="user-update-header">
          <div className="user-update-title">
            <h2>Update Profile</h2>
          </div>
        </div>
        <I2cAlert
          open={alertState ? true : false}
          className="alert mt_alert_24"
          variant={variantType}
          type="plain"
          layout="layoutAsideLeft"
          headerArt="cs-linear-alert-circle"
          duration={5000}
          closable
        >
          <span slot="label">{alertMsg}</span>
        </I2cAlert>
        <form
          onSubmit={handleSubmit(handleUserUpdation)}
          ref={form}
          autoComplete="on"
        >
          <div className="user-form">
            <div onClick={handleButtonClick}>
              <AlertMessage
                open={isUserUpdationError}
                message={"Something went wrong."}
              />
            </div>
            <div onClick={handleButtonClick}>
              <AlertMessage
                variant="success"
                message={"Profile updated successfully"}
                headerArt="linear-tick-circle"
                open={isUserUpdated}
                closeAble={true}
              />
            </div>
            <div className="user-form-user-avatar">
              <Controller
                name="avatar"
                control={methods.control}
                render={({ field }) => (
                  <>
                    <I2cFileUpload
                      {...field}
                      auto-upload
                      loader-style="circular"
                      icon={null}
                      label=""
                      ref={Manual}
                      multiple={false}
                      caption=""
                      message=""
                      no-fp-item-upload-btn
                      onI2cUploadComplete={field.onchange}
                    ></I2cFileUpload>
                    <I2cAvatar
                      className="table-avatar"
                      image={
                        profileImg ||
                        `data:image/jpeg;base64,${user?.data?.data?.user?.avatar}`
                      }
                      name="User Avatar"
                      info="Click on the image to update avatar."
                      label="User Avatar"
                      size="2xl"
                      onClick={handleAvatarClick}
                    ></I2cAvatar>
                  </>
                )}
              />
            </div>
            <I2cDivider
              style={{
                "--borderWidth": "1px",
                "--border-color": "var(--border-secondary)",
              }}
            >
              {" "}
            </I2cDivider>
            <div className="user-form-fields-container">
              <div className="form-single-field-wrapper">
                <Controller
                  name="name"
                  control={methods.control}
                  render={({ field }) => (
                    <I2cInput
                      size="large"
                      label="Name"
                      placeholder="Enter Name"
                      name="name"
                      required
                      value={methods.watch("name")}
                      className={`auth__custom-input fw-500`}
                      invalid={errors.name ? true : false}
                      onI2cInput={field.onChange}
                      onI2cBlur={field.onBlur}
                    ></I2cInput>
                  )}
                />
                {/* <ErrorMessage
                  show={errors.name ? true : false}
                  message={errors.name?.message ?? "Invalid input"}
                /> */}
              </div>
              <div className="form-single-field-wrapper">
                <Controller
                  name="email"
                  control={methods.control}
                  render={({ field }) => (
                    <I2cInput
                      size="large"
                      label="Email"
                      placeholder="Enter User Email"
                      name="email"
                      required
                      type="email"
                      value={methods.watch("email")}
                      disabled={true}
                      className={`auth__custom-input fw-500`}
                      invalid={errors.email ? true : false}
                      onI2cInput={field.onChange}
                      onI2cBlur={field.onBlur}
                    ></I2cInput>
                  )}
                />
                {/* <ErrorMessage
                  show={errors.email ? true : false}
                  message={errors.email?.message ?? "Invalid input"}
                /> */}
              </div>
              <div className="form-single-field-wrapper">
                <Controller
                  name="designation"
                  control={methods.control}
                  render={({ field }) => (
                    <I2cInput
                      size="large"
                      label="Designation"
                      required
                      placeholder="Enter Designation"
                      value={methods.watch("designation")}
                      name="designation"
                      className={`auth__custom-input fw-500`}
                      invalid={errors.designation ? true : false}
                      onI2cInput={field.onChange}
                      onI2cBlur={field.onBlur}
                    ></I2cInput>
                  )}
                />
                {/* <ErrorMessage
                  show={errors.designation ? true : false}
                  message={errors.designation?.message ?? "Invalid input"}
                /> */}
              </div>
              <div className="form-single-field-wrapper">
                <I2cPhoneField
                  format="INTERNATIONAL"
                  label="Contact Number"
                  tooltip-help="Contact Number"
                  name="contact"
                  size="large"
                  country-box
                  required
                  className="auth__custom-input fw-500"
                  selectedCountry={methods.watch("country_code")}
                  value={methods.watch("contact")}
                  errorMessageVisible={false}
                  onI2cChange={(e) => {
                    const country = e.target.country;
                    const isValid = e.target.isValid;
                    const value = e.target.value;
                    // methods.setValue("country_code", country);
                    methods.setValue("contact", value);
                    if (!isValid) {
                      methods.setError("contact", {
                        message: e.target.guide,
                      });
                    } else {
                      methods.clearErrors("contact");
                    }
                  }}
                />
              </div>
              <div className="form-single-field-wrapper">
                <Controller
                  name="company"
                  control={methods.control}
                  render={({ field }) => (
                    <I2cInput
                      size="large" 
                      label="Company Name"
                      placeholder="Enter Company Name"
                      name="company"
                      required
                      value={methods.watch("company")}
                      className={`auth__custom-input fw-500`}
                      invalid={errors.company ? true : false}
                      onI2cInput={field.onChange}
                      onI2cBlur={field.onBlur}
                    ></I2cInput>
                  )}
                />
                {/* <ErrorMessage
                  show={errors.company ? true : false}
                  message={errors.company?.message ?? "Invalid input"}
                /> */}
              </div>
              {/* <div className="form-single-field-wrapper">
                <Controller
                  name="working_hrs"
                  control={methods.control}
                  render={({ field }) => (
                    <I2cInput
                      size="large"
                      label="Working Hours"
                      nospin={true}
                      type="number"
                      value={methods.watch("working_hrs")}
                      placeholder="Enter Working Hours"
                      name="working_hrs"
                      required
                      className={`auth__custom-input fw-500`}
                      invalid={errors.working_hrs ? true : false}
                      onI2cInput={(e) => {
                        const val = parseFloat(e.target.value);
                        if (isNaN(val)) field.onChange(0);
                        else field.onChange(parseFloat(e.target.value));
                      }}
                      min={1}
                      max={24}
                      onI2cBlur={field.onBlur}
                    />
                  )}
                />
                <ErrorMessage
                  show={errors.working_hrs ? true : false}
                  message={errors.working_hrs?.message ?? "Invalid input"}
                />
              </div> */}
            </div>
            <div className="form-footer">
              <I2cButton
                variant="secondary gray"
                onClick={() => {
                  setOpen(true);
                  setAlertState(false);
                }}
                className="form-footer-common-button"
              >
                Change Password
              </I2cButton>
              <div className="cta-innerFlex">
                <I2cButton
                  className="form-footer-cancel-button form-footer-common-button"
                  variant="secondary gray"
                  onClick={() => navigate("/sales")}
                  loading={userUpdation.isLoading}
                  disabled={userUpdation.isLoading}
                >
                  Cancel
                </I2cButton>
                <I2cButton
                  className="form-footer-submit-button form-footer-common-button"
                  variant="primary"
                  type="submit"
                  loading={userUpdation.isLoading}
                  disabled={
                    Object.keys(errors).length || userUpdation.isLoading
                  }
                >
                  Update Profile
                </I2cButton>
              </div>
            </div>
          </div>
        </form>
      </div>
      {(isLoading || loader || userUpdation.isLoading) && <OverlayLoader />}
      {open ? (
        <>
          <I2cDialog
            className="custom-dialog dialog2"
            label="Change Password"
            headerArt="linear-password-check"
            layout="layoutCenter"
            headerArtStyle="shadowed"
            variant="primary"
            open={open}
            onI2cHide={(event) => {
              if (event.target.tagName === "I2C-DIALOG") {
                setOpen(false);
                setCurrentPass("");
                setNewPass("");
                setNewConfirmPass("");
              }
            }}
            closable
          >
            <p>
              For security Purposes, it is recommended that you change your
              password/passphrase regularly. Your password/passphrase will
              expire in ninty (90) days.
            </p>

            <div className="fields-container">
              <div className="resetPass__form-group">
                <I2cInput
                  size="large"
                  label="Current Password"
                  placeholder="Enter Current Password"
                  name="currentPassword"
                  className="auth__custom-input"
                  required
                  autofocus
                  errorMessageVisible
                  type="password"
                  togglePassword={true}
                  invalid={errors.currentPass ? true : false}
                  onI2cInput={(e) => {
                    setCurrentPass(e.target.value ?? "");
                  }}
                >
                  <I2cIcon slot="hide-password-icon" name={"linear-eye"} />
                  <I2cIcon
                    slot="show-password-icon"
                    name={"linear-eye-slash"}
                  />
                </I2cInput>
                <ErrorMessage
                  show={errors.currentPass ? true : false}
                  message={errors.currentPass?.message ?? "Invalid input"}
                />
              </div>
              <div className="resetPass__form-group margin-0">
                <I2cPasswordField
                  name="createNewPassword"
                  className="auth__custom-input"
                  onI2cChange={(e) => {
                    setNewPass(e.target.value ?? "");
                  }}
                  toggle-password
                  placeholder="Enter New Password"
                  label="New Password"
                  pattern="^(?=.*[0-9])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{8,}$"
                  required
                  autofocus
                  errorMessageVisible={true}
                  togglePassword={true}
                  strength-box
                  size="large"
                  conditions={[
                    {
                      text: "Special character",
                      srOnlyText: "1 Special Character",
                      regexValue: ".*[^a-zA-Z0-9].*",
                      status: false,
                    },
                    {
                      text: "Minimum 13 characters",
                      srOnlyText:
                        "password length should be minimum 13 characters",
                      regexValue: "^.{13,}$",
                      status: false,
                    },
                    {
                      text: "Number",
                      srOnlyText: "1 Number",
                      regexValue: ".*[0-9].*",
                      status: false,
                    },
                    {
                      text: "Capital Letter",
                      srOnlyText: "! Capital ",
                      regexValue: "[A-Z]",
                      status: false,
                    },
                  ]}
                />
                {/* <I2cInput
              size="large"
              label="New Password"
              placeholder="Enter New Password"
              name="createNewPassword"
              className="auth__custom-input"
              required
              autofocus
              errorMessageVisible
              type="password"
              onI2cInput={(e) => {
                setNewPass(e.target.value ?? "");
              }}
              togglePassword={true}
            >
              <I2cIcon slot="hide-password-icon" name={"linear-eye"} />
              <I2cIcon slot="show-password-icon" name={"linear-eye-slash"} />
            </I2cInput> */}
                <ErrorMessage
                  show={errors.newPass ? true : false}
                  message={errors.newPass?.message ?? "Invalid input"}
                />
              </div>
              <div className="validMargin">
                {/* <PasswordValidator passwordValidator={newPass} /> */}
              </div>
              <div className="resetPass__form-group margin-0">
                <I2cInput
                  size="large"
                  type="password"
                  label="Confirm New Password"
                  placeholder="Confirm New Password"
                  name="confirmNewPassword"
                  className="login__custom-input"
                  errorMessageVisible={false}
                  required
                  togglePassword={true}
                  onI2cInput={(e) => {
                    setNewConfirmPass(e.target.value ?? "");
                  }}
                >
                  <I2cIcon slot="hide-password-icon" name={"linear-eye"} />
                  <I2cIcon
                    slot="show-password-icon"
                    name={"linear-eye-slash"}
                  />
                </I2cInput>
                <ErrorMessage
                  show={!isConfirmPassMatch}
                  message="Passwords do not match"
                />
              </div>
            </div>
            <footer slot="footer">
              <I2cButton
                slot="footer"
                variant="secondary gray"
                onClick={() => setOpen(false)}
              >
                Cancel
              </I2cButton>
              <I2cButton
                type="submit"
                slot="footer"
                variant="primary"
                onClick={handlePasswordSubmit}
                disabled={
                  validStepCount < 4 ||
                  !isConfirmPassMatch ||
                  !currentPass.length
                }
              >
                Update
              </I2cButton>
            </footer>
          </I2cDialog>
        </>
      ) : (
        ""
      )}
    </React.Fragment>
  );
};

export default UserPofile;
